import { Outlet } from 'react-router-dom'
import { SiteBanner } from './SiteBanner'
import SiteFooter from './SiteFooter'
import SiteHeader from './SiteHeader'

/** The site's own frame: skip link, banner, header, the page, and the footer. */
export default function SiteLayout() {
  return (
    <div className="app-shell">
      <a href="#main" className="skip-link">
        Skip to main content
      </a>
      <SiteBanner />
      <SiteHeader />
      <main id="main" tabIndex={-1}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  )
}
